import * as React from 'react';
import {LocationsDTO} from "./model/LocationsDTO";
import {CourseTypesDTO} from "./model/CourseTypesDTO";
import {CourseTypeDTO} from "./model/CourseTypeDTO";
import {LocationDTO} from "./model/LocationDTO";
import {PersonsDTO} from "./model/PersonsDTO";
import {TagsDTO} from "./model/TagsDTO";
import {BoxDTO} from "./model/BoxDTO";
import {ContractDTO} from "./model/ContractDTO";
import {ContractsDTO} from "./model/ContractsDTO";
import {CourseDTO} from "./model/Course";
import {PersonDTO} from "./model/PersonDTO";
import {EmailStringsDTO} from "./model/EmailStringsDTO";
import {EmailStringDTO} from "./model/EmailStringDTO";
import {WeekDTO} from "./model/WeekDTO";
import {ProductDTO} from "./model/ProductDTO";
import {ProductsDTO} from "./model/ProductsDTO";

type APIContextType = {
  setLoading: (state: boolean) => void,
  setUpdating: (state: boolean) => void,
  fetchLocations: () => Promise<LocationsDTO>,
  pushLocation: (location: LocationDTO) => Promise<LocationDTO>,
  fetchCourseTypes: () => Promise<CourseTypesDTO>,
  fetchCoaches: () => Promise<PersonsDTO>,
  pushCourseType: (type: CourseTypeDTO) => Promise<CourseTypeDTO>,
  deleteCourseType: (id: CourseTypeDTO) => Promise<CourseTypeDTO>,
  getTags: ()=>Promise<TagsDTO>
  saveTags: (tags: TagsDTO)=>Promise<TagsDTO>
  saveBox: (box: BoxDTO)=>Promise<BoxDTO>
  saveContract: (contract: ContractDTO)=>Promise<ContractDTO>
  getContracts: (force: boolean)=>Promise<ContractsDTO>
  saveProduct: (product: ProductDTO)=>Promise<ProductDTO>
  getProducts: ()=>Promise<ProductsDTO>
  signInPerson: (course: string, person: string)=>Promise<CourseDTO>
  signOutPerson: (course: string, person: string)=>Promise<CourseDTO>
  addUser: (person: PersonDTO)=>Promise<PersonDTO>
  getEmailStrings: ()=>Promise<EmailStringsDTO>
  saveEmailString: (string: EmailStringDTO)=>Promise<EmailStringDTO>
  testEmailStrings: ()=>Promise<string>
  getWeek: (date: Date)=>Promise<WeekDTO>
  enablePersonForPayment: (id: string)=>Promise<PersonDTO>
  enableContractForPayment: (id: string)=>Promise<ContractDTO>
  disableContractForPayment: (id: string)=>Promise<ContractDTO>
  enableProductForPayment: (id: string)=>Promise<ProductDTO>
  disableProductForPayment: (id: string)=>Promise<ProductDTO>
  fetchPrograms: (startDate: string, endDate: string, type: string, loading: boolean)=>Promise<any>
  logout: () => void
}

export const APIContext = React.createContext<APIContextType>({
  setLoading: (_: boolean) => {},
  setUpdating: (_: boolean) => {},
  fetchLocations: () =>  new Promise<LocationsDTO>((_) => {}),
  pushLocation: (_: LocationDTO) =>  new Promise<LocationDTO>((_) => {}),
  fetchCourseTypes: () => new Promise<CourseTypesDTO>((_) => {}),
  fetchCoaches: () => new Promise<PersonsDTO>((_) => {}),
  pushCourseType: (_: CourseTypeDTO) => new Promise<CourseTypeDTO>((_) => {}),
  deleteCourseType: (_: CourseTypeDTO) => new Promise<CourseTypeDTO>((_)=>{}),
  getTags: () => new Promise<TagsDTO>((_) => {}),
  saveTags: (_) => new Promise<TagsDTO>((_) => {}),
  saveBox: (_) => new Promise<BoxDTO>((_) => {}),
  saveContract: (_) => new Promise<ContractDTO>((_) => {}),
  getContracts: (_: boolean) => new Promise<ContractsDTO>((_) => {}),
  saveProduct: (_) => new Promise<ProductDTO>((_) => {}),
  getProducts: () => new Promise<ProductsDTO>((_) => {}),
  signInPerson: (_: string, __: string) => new Promise<CourseDTO>((_) => {}),
  signOutPerson: (_: string, __: string) => new Promise<CourseDTO>((_) => {}),
  addUser: (_: PersonDTO) => new Promise<PersonDTO>((_) => {}),
  getEmailStrings: ()=>new Promise<EmailStringsDTO>((_)=>{}),
  saveEmailString: (_: EmailStringDTO)=>new Promise<EmailStringDTO>((_)=>{}),
  testEmailStrings: ()=>new Promise<string>((_)=>{}),
  getWeek: (_: Date)=>new Promise<WeekDTO>((_)=>{}),
  enablePersonForPayment: (_: string)=>new Promise<PersonDTO>((_)=>{}),
  enableContractForPayment: (_: string)=>new Promise<ContractDTO>((_)=>{}),
  disableContractForPayment: (_: string)=>new Promise<ContractDTO>((_)=>{}),
  enableProductForPayment: (_: string)=>new Promise<ProductDTO>((_)=>{}),
  disableProductForPayment: (_: string)=>new Promise<ProductDTO>((_)=>{}),
  fetchPrograms: (_: string, __: string, ___: string, ____: boolean) => new Promise(()=>{}),
  logout: () => {},
});

export const TabMenuContext = React.createContext({
  setActionP: null,
  setActionPText: null,
})

export function defineBackend(backendParam: any){
  if(!isNaN(backendParam)){
    return "https://weexplan.com/weex" + backendParam;
  }
  else{
    if(backendParam.includes("weex")){
      return "https://weexplan.com/" + backendParam;
    }
    else{
      return "http://" + backendParam;
    }
  }
}
